'use client';

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import i18nConfig from './config';

i18next
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language, namespace) =>
        import(`../public/locales/${language}/${namespace}.json`)
    )
  )
  .init({
    ...i18nConfig,
    lng: i18nConfig.defaultLocale,
    fallbackLng: i18nConfig.defaultLocale,
    supportedLngs: i18nConfig.locales,
    react: {
      useSuspense: false
    }
  });

export default i18next;
